module.exports = __webpack_public_path__ + "img/DE01047.82507dc4.png";